import { FormControl, FormGroup } from "@angular/forms";

/**
 * removes indexes other than actual keys of T, even when it extends { [key: string]: <any> }
 */
export type NarrowIndexable<T> = {
    [K in keyof T as string extends K ? never : number extends K ? never : K]: T[K];
};

/**
 * get the type of elements inside of an array
 */
export type ArrayElementType<T> = T extends (infer U)[] ? U : never;

/**
 * creates form type from object interface
 */
export type FormType<T extends object> = { [key in keyof T]: FormControl<T[key]> };

/**
 * a branding type to wrap some other object type to make it not nestable when using DeepFormType
 */
declare const NotNestableFormTypeBrand: unique symbol;
export type NotNestableFormType<T extends object> = T & { [NotNestableFormTypeBrand]: true };

/**
 * creates form type from deep object interface
 */
export type DeepFormType<T extends object> = {
    [key in keyof T]: T[key] extends string | number | boolean | Date | symbol | undefined | null | NotNestableFormType<T[key]>
        ? FormControl<T[key]>
        : T[key] extends object
        ? FormGroup<DeepFormType<Required<T[key]>>>
        : never;
};

/**
 * creates object interface from other object interface but with NonNullable properties
 */
export type DeepNonNullable<T extends object, KeysToOmit extends keyof T = never> = {
    [key in keyof T]: key extends KeysToOmit ? T[key] : NonNullable<T[key]>;
};
